import React, { ChangeEventHandler, FunctionComponent } from 'react';
import PhotoIcon from '../icons/PhotoIcon';
import './avatarImageUpload.scss';
import ProfileIcon from '../icons/ProfileIcon';

type Props = {
  photo: string;
  onChange: ChangeEventHandler;
}

const AvatarImageUpload: FunctionComponent<Props> = ({ photo = '', onChange }) => (
  <label className="avatar-image-upload" htmlFor="avatar-upload-input" data-testid="avatar-image-upload">
    {photo ? (
      <img
        className="image-upload-avatar"
        alt="Driver"
        src={photo}
      />
    ) : (
      <div className="placeholder-container">
        <ProfileIcon width={50} color="asphalt7" />
      </div>
    )}
    <span className="icon-container">
      <PhotoIcon width={36} color="light" className="photo-icon" />
    </span>
    <input
      id="avatar-upload-input"
      className="image-upload-input"
      type="file"
      onChange={onChange}
    />
  </label>
);

export default AvatarImageUpload;
